import React from 'react'
import classNames from 'classnames'

import style from './screen.css'

// has a header, content and footer.
export default class Screen extends React.Component {
  
  render() {

    const { className, ...rest } = this.props
    return (
      <div className={classNames( style.screen, className )} {...rest} />
    )
  }

}

class Header extends React.Component {

  render() {

    const { className, ...rest } = this.props
    return (
      <div className={classNames( style.header, className )} {...rest} />
    )
  }
}

class Content extends React.Component {

  render() {

    const { className, ...rest } = this.props
    return (
      <div className={classNames( style.content, className )} {...rest} />
    )
  }
}

class Footer extends React.Component {

  render() {

    const { className, ...rest } = this.props
    return (
      <div className={classNames( style.footer, className )} {...rest} />
    )
  }
}

Screen.Header = Header
Screen.Content = Content
Screen.Footer = Footer
